import { DateTime } from "luxon";

export class SubscriberPresenter {
  constructor(data) {
    const id = data.id;
    const pack = {
      name: data.current_package.name,
      quality: `จำนวน ${data.quality || 1} แพ็คเกจ`
    };

    const lastBillingCycle = data.histories
      ? data.histories.map(history => {
          const isDisableAppointmentByNoteInvoice = history.invoice
            ? history.invoice.is_disable_appointment_by_note_invoice
            : null;

          const cancelledAt = history.cancelled_at
            ? DateTime.fromISO(history.cancelled_at)
            : null;
          const hasExpired = DateTime.fromISO(data.expired_at) > DateTime.now();
          const canMakeAppointment =
            (hasExpired && !Boolean(cancelledAt)) ||
            (hasExpired &&
              Boolean(cancelledAt) &&
              cancelledAt < DateTime.fromISO(data.expired_at));

          return {
            isDisableAppointmentByNoteInvoice,
            canMakeAppointment
          };
        })[0]
      : null;

    const services = data.services.map(service => {
      const {
        id,
        name,
        description,
        short_description: shortDescription,
        icon: iconUrl,
        type,
        quota,
        main_option_title: mainOption,
        extra_option_titles: extraOption,
        provider
      } = service;

      return {
        id,
        name,
        description,
        shortDescription,
        iconUrl,
        type,
        quota,
        mainOption,
        extraOption,
        providerId: provider.id
      };
    });

    const subscriber = {
      id,
      package: pack,
      lastBillingCycle,
      services
    };

    this.registrationForm = data.registration_form;
    this.subscriber = subscriber;
  }
}



// WEBPACK FOOTER //
// ./src/components/other-web/supplier/presenters/SubscriberPresenter.js